import {
  paginationStyle,
  statusStyle,
  glyphIconStyle,
  helpbuttonStyle,
  uiblockerStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { getLogsGridStyle } from './logs-grid-style';
import { getScheduleGridStyle, getGoogleAdsAccountViewStyle } from './schedule-grid-style';
import { getImportsCommonStyle } from './common-styles';

export const getImportScheduleGridViewStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  topGridPanelCustomStyles: {
    '& .preference-upload-form.panel': {
      '&.form-horizontal .control-label': {
        padding: '0 0 8px 0',
      },
      '& .col-sm-3': {
        width: 'unset',
      },
      '& .col-sm-3, & .col-sm-6, & .col-sm-8': {
        float: 'unset',
        paddingLeft: 'unset',
      },
      '& .preference-upload-description': {
        marginTop: 5,
        marginBottom: 20,
      },
    },
  },
  '@global': Object.assign(
    {
      '#import-recommendation-callout': {
        maxWidth: 'unset',
        width: 300,
        '& .recommendation-popup': {
          padding: 12,
          fontSize: 14,
          '& .title': {
            marginBottom: 10,
          },
          '& .operation': {
            display: 'flex',
            'justify-content': 'space-between',
          },
        },
        '& .popover-content': {
          padding: 0,
          '& span.iconba.iconba-ChevronRightMed, & span.iconba.iconba-ChevronLeftMed': {
            marginLeft: 5,
            top: 10,
            color: palette.themePrimary,
          },
          '& .insight_icon': {
            color: palette.themePrimary,
          },
        },
      },
    },
    uiblockerStyle({ palette }),
    glyphIconStyle({ palette, iconFontFamily }),
    getGoogleAdsAccountViewStyle({ palette }),
    helpbuttonStyle({ palette })
  ),
  ImportErrorResolutionContainer: {
    padding: '0 32px',
    margin: '16px 0',
  },
  importSchedulePage: Object.assign(
    {},
    statusStyle({ palette }),
    paginationStyle({ palette }),
    getImportsCommonStyle({ palette }),
    {
      '& .section-body.log': getLogsGridStyle({ palette }),
      '& .section-body.schedule': getScheduleGridStyle({ palette, iconFontFamily }),
    }
  ),
});
